module.exports = __webpack_public_path__ + "img/open.144ea7d7.svg";